import type { TeacherCohortAssignmentRecord } from "../auth/api-client";

/** Stable lesson-plan order: explicit plan position, then created time, then id. */
export function sortCohortAssignmentsByPlan(
  assignments: readonly TeacherCohortAssignmentRecord[]
): TeacherCohortAssignmentRecord[] {
  return [...assignments].sort((a, b) => {
    const ap = a.planPosition ?? Number.MAX_SAFE_INTEGER;
    const bp = b.planPosition ?? Number.MAX_SAFE_INTEGER;
    if (ap !== bp) return ap - bp;
    const created = a.createdAt.localeCompare(b.createdAt);
    if (created !== 0) return created;
    return a.id.localeCompare(b.id);
  });
}
